export function itemMutationId(item) {
  return String(item?.client_mutation_id || item?.clientMutationId || '').trim()
}

export function mergeCreatedItem(list, created) {
  const items = Array.isArray(list) ? list : []
  if (!created) return items
  const mutationId = itemMutationId(created)
  const pendingId = mutationId ? `pending-${mutationId}` : ''
  const incomingPending = String(created.id || '').startsWith('pending-')
  const index = items.findIndex((entry) => (
    (created.id && entry.id === created.id)
    || (pendingId && entry.id === pendingId)
    || (mutationId && itemMutationId(entry) === mutationId)
  ))
  if (index >= 0) {
    const current = items[index]
    const currentPending = String(current.id || '').startsWith('pending-')
    if (!currentPending && incomingPending) return items
    const next = items.slice()
    next[index] = incomingPending
      ? { ...current, ...created, id: currentPending ? created.id : current.id }
      : {
          ...current,
          ...created,
          id: created.id,
          sync_pending: false,
          sync_status: created.sync_status || 'saved',
        }
    return next
  }
  if (!created.id) return items
  return [...items, created]
}

export function attachPendingScans(serverItems, entries, cartId) {
  const items = Array.isArray(serverItems) ? [...serverItems] : []
  const pending = (entries || [])
    .filter((entry) => String(entry.cartId) === String(cartId))
    .filter((entry) => entry.status !== 'saved')
    .map((entry) => ({
      ...(entry.draftPayload || {}),
      id: `pending-${entry.clientMutationId}`,
      cart_id: cartId,
      client_mutation_id: entry.clientMutationId,
      sync_pending: entry.status !== 'failed',
      sync_status: entry.status || 'pending',
      sync_error: entry.lastError || '',
    }))
  return pending.reduce((list, item) => mergeCreatedItem(list, item), items)
}

export function buildAddSuccessPayload(created, notice = '') {
  if (!created || typeof created !== 'object') return null
  return {
    id: created.id,
    name: created.name,
    image_url: created.image_url,
    notice: notice || created.notice || '',
  }
}

export function nextAddProductUiState({ created, error, notice = '' }) {
  if (error) {
    return {
      keepForm: true,
      successPayload: null,
      error: error.message || 'Impossible d’ajouter le produit.',
    }
  }
  return {
    keepForm: false,
    successPayload: buildAddSuccessPayload(created, notice),
    error: '',
  }
}
